<template>
  <div class="wl-results" v-if="doc">
    <results-bar :doc="doc" @loadSummary="loadSummary" @loadWords="loadWords" @loadUser="loadUser"></results-bar>
    <results-summary v-if="summary" :id="doc.id"></results-summary>
    <results-words v-if="words" :id="doc.id"></results-words>
    <results-user v-if="!summary" :uid="currentUser"></results-user>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { store } from '@/store.js'
import {
  ResultsUser,
  ResultsBar,
  ResultsSummary,
  ResultsWords
} from "@/components/results/messages";
const fb = require("@/firebaseConfig.js");
export default {
  name: "ResultMessages",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      summary: true,
      words: false,
      summaryMode: "popular",
      currentUser: null,
      userList: null
    };
  },
  components: {
    ResultsUser,
    ResultsBar,
    ResultsSummary,
    ResultsWords
  },
  mounted() {
    this.getExercise();
  },
  computed: {
    ...mapState(["exMessages"])
  },
  methods: {
    loadSummary() {
      this.currentUser = null;
      this.summary = true;
      this.words = false;
    },
    loadWords() {
      this.currentUser = null;
      this.summary = false;
      this.words = true;
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.summary = false;
      this.words = false;
    },
    getExercise() {
      let ref = fb.messageExCollection.where("pid", "==", this.doc.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          let users = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            users.push(post.uid);
            
            post.doc.forEach((item) => {
              items.push(item);
            });
          });
          if (items) {
            // this.exList = items;
             store.commit('setExMessages', items)
          }
          if (users) {
            this.userList = users;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
